import { render, staticRenderFns } from "./fileDropUpload.vue?vue&type=template&id=4cb2b8ac&scoped=true"
import script from "./fileDropUpload.vue?vue&type=script&lang=js"
export * from "./fileDropUpload.vue?vue&type=script&lang=js"
import style0 from "./fileDropUpload.vue?vue&type=style&index=0&id=4cb2b8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2b8ac",
  null
  
)

export default component.exports